import React from 'react';
import { FormattedMessage } from 'react-intl';
import { InstantBook } from '../icons';

const InstaBook = () => {
  return (
    <div className="responsive-wrapper insta-book">
      <InstantBook className="margin-sm-right" style={{ height: 20 }} />
      <span>
        <FormattedMessage
          id="shared_components.insta_book.text"
          defaultMessage="Instant Book"
        />
      </span>
    </div>
  );
};

export default InstaBook;
